/**
 * Generate a unique DOM element id.
 */
export default function uniqueId(byteCount: number = 4) {
  const bytes = new Uint8Array(byteCount);
  crypto.getRandomValues(bytes);
  return (
    "X-" +
    bytes.reduce(
      (partial, byte) => partial + ("0" + byte.toString(16)).slice(-2),
      ""
    )
  );
}
